import { useStripe } from '@stripe/react-stripe-js';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Success from './Success';
import { Button } from '@wot/components';
import { UNDER_REVIEW } from '../../../assets/images';
import { FAILED_ANIMATED } from '../../../assets/animated';
import  NAV_LOGO  from '../../../assets/logos/World_O_Tutor.webp';

const PaymentProcessing = () => {
  const stripe = useStripe();
  const [message, setMessage] = useState('');
  const [paymentStatus, setPaymentStatus] = useState<'success' | 'processing' | 'failed'>('success');
  const navigate = useNavigate();
  const [pageNotFound, setPageNotFound] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }
    // Retrieve the "payment_intent_client_secret" query parameter appended to
    // your return_url by Stripe.js
    const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');
    const planId = new URLSearchParams(window.location.search).get('planId');

    if (clientSecret) {
      // Retrieve the PaymentIntent
      stripe.retrievePaymentIntent(clientSecret).then(async ({ paymentIntent }) => {
        // Inspect the PaymentIntent `status` to indicate the status of the payment
        // to your customer.
        //
        // Some payment methods will [immediately succeed or fail][0] upon
        // confirmation, while others will first enter a `processing` state.
        //
        // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
        if (paymentIntent) {
          console.log(paymentIntent);
          switch (paymentIntent.status) {
            case 'succeeded':
              setPaymentStatus('success');
              setMessage('Success! Payment received.');
              break;

            case 'processing':
              setPaymentStatus('processing');
              setMessage("Payment processing. We'll update you when payment is received.");
              break;

            case 'requires_payment_method':
              // Redirect your user back to your payment page to attempt collecting
              // payment again
              navigate(-1);
              setPaymentStatus('failed');
              setMessage('Payment failed. Please try another payment method.');
              break;

            default:
              setPaymentStatus('failed');
              setMessage('Something went wrong.');
              break;
          }
        }
      });
    } else {
      setPageNotFound(true);
    }
  }, [stripe]);

  if (pageNotFound) {
    return (
      <div className="w-full h-full min-h-screen text-white flex flex-col items-center justify-center">
        <img src={NAV_LOGO} alt="WorldOTutor logo" className="h-10 my-4" />
        <h1 className='text-base font-normal text-black'>Page not found</h1>
      </div>
    );
  }

  return (
    <div className="w-full h-full min-h-screen bg-black/25 z-50 flex items-center justify-center px-4">
      <div className="w-full h-[400px] max-w-lg mx-auto bg-white rounded-2xl overflow-hidden">
        {paymentStatus === 'success' && <Success planId={new URLSearchParams(window.location.search).get('planId') || ""} />}
        {paymentStatus === 'processing' && (
          <div className="w-full h-full flex flex-col gap-7 items-start bg-white rounded-2xl px-7 py-8 z-20">
            <h3 className="w-full text-lg font-bold text-center">Payment Processing</h3>
            <div className="w-full flex items-center justify-center">
              <img src={UNDER_REVIEW} className="h-8 my-7 animate-spin" />
            </div>
          </div>
        )}
        {paymentStatus === 'failed' && (
          <div className="w-full h-full flex flex-col gap-7 items-start bg-white rounded-2xl px-7 py-8 z-20">
            <h3 className="w-full text-lg font-bold text-center">Payment Failed</h3>
            <div className="w-full grow flex flex-col items-center justify-center gap-2 px-7 py-7">
              <img src={FAILED_ANIMATED} className="w-20 h-20" />
              <div className="w-full mt-auto">
                <Button block text="Try Again" type="primary" onClick={() => navigate(-1)} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentProcessing;
